import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { IMG } from "@/lib/content";
import { PricingTable, IncludeList } from "@/components/Pricing";

export default function Residential() {
  const [service, setService] = useState(null);
  useEffect(() => { api.get("/services").then((r) => setService(r.data.find((s) => s.slug === "residential"))).catch(() => {}); }, []);

  return (
    <div>
      <section className="relative h-[46vh] min-h-[340px]">
        <img src={IMG.residentialLiving} alt="Bright, freshly cleaned living room" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-end pb-12">
          <p className="text-xs uppercase tracking-[0.25em] text-white/90">For your home</p>
          <h1 className="mt-2 font-serif text-4xl sm:text-5xl text-white font-semibold">Residential Standard Cleaning</h1>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2 space-y-6">
          <p className="text-lg text-[#635B52] leading-relaxed">
            A thorough, refreshing clean that keeps your home feeling calm and cared for. These prices cover homes in
            <strong className="text-[#2C2621]"> normal maintained condition</strong>.
          </p>
          <div className="bg-[#F5F0E8] border-l-4 border-[#B87333] rounded-r-xl p-5 text-[#2C2621]">
            Large properties, excessive buildup, or special conditions may require a revised quote.
          </div>
          <h2 className="font-serif text-2xl text-[#2C2621] pt-2">Standard cleaning includes</h2>
          <IncludeList items={[
            "Dusting of reachable surfaces and furniture",
            "Kitchen counters, sink, and exterior appliance wipe-down",
            "Bathroom cleaning and sanitizing",
            "Floors vacuumed and mopped throughout",
            "Trash removal and tidying",
            "Beds made (linens provided by you)",
          ]} />
        </div>
        <div className="bg-white rounded-2xl border border-[#E6DEC3] p-6 h-fit shadow-[0_4px_20px_rgba(44,38,33,0.04)]">
          <h3 className="font-serif text-xl text-[#2C2621]">Add extras any time</h3>
          <ul className="mt-4 space-y-2 text-sm text-[#635B52]">
            <li>• Inside oven or refrigerator</li>
            <li>• Laundry service</li>
            <li>• Extra bedrooms or bathrooms</li>
          </ul>
          <Link to="/book?service=residential" className="mt-6 block text-center bg-[#B87333] hover:bg-[#A06127] text-white font-medium rounded-full px-5 py-3 transition-all" data-testid="residential-book-btn">Book a cleaning</Link>
        </div>
      </div>

      <section className="bg-[#F5F0E8] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-serif text-3xl text-[#2C2621] mb-8">Residential pricing</h2>
          <PricingTable service={service} />
        </div>
      </section>
    </div>
  );
}
